module.exports = __webpack_public_path__ + "img/2-5.98754639.png";